import { render } from "./TVGuide.vue?vue&type=template&id=9b75142a&scoped=true"
import script from "./TVGuide.vue?vue&type=script&lang=js"
export * from "./TVGuide.vue?vue&type=script&lang=js"

import "./TVGuide.vue?vue&type=style&index=0&id=9b75142a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b75142a"]])

export default __exports__